import "./style/style2.css"
import Card from './Card';
import FooterHome from './FooterHome';


import magnifierIcon from './images/icons/Magnifier Icon Mographical.svg';
import threeDIcon from './images/icons/3D Icon Mographical.svg';
import objectsIcon from './images/icons/Objects Icon Mographical.svg';

import arrowDown from './images/arrow-down.svg'

import folioOdenlo from './images/Odenlo - Frontend-Developer-React-Nextjs.jpg'
import folioDishop from './images/UX-UI-Project-Mobile-App-Dishop-Food.png'
import folioFleet from './images/UX-UI-Project-Mobile-App-Fleet.png'
import folioProjectsUI from './images/UX-UI-Project-Web-App-Dashboards.png'

import YBlogo from './images/Yacin-Benziane-Logo.png'

import {Link } from 'react-router-dom';

import { useState } from 'react';

import {  useLenis } from '@studio-freight/react-lenis'


import { motion, useScroll, AnimatePresence } from 'framer-motion';

import ScrollToTop from './ScrollToTop';
import FolioCard from "./FolioCard";


import { useRef } from 'react';


var cclick = false;
var lockedPosition = null;

//UX Cards
const UXCard1 = {
  title: 'Research & Define',
  parag: 'Project goals, user needs, and technical constraints are clarified through stakeholder interviews, user research, and competitive analysis. This phase lays the foundation for UX/UI design with clear requirements, user flows, and wireframes.',
  icon: magnifierIcon,
  alt: 'Magnifying Glass Icon',
}
    
const UXCard2 = {
  title: 'Build & Iterate',
  parag: 'UX/UI design evolves into interactive prototypes and component-based systems. Front-end development translates designs into responsive, accessible interfaces using modern frameworks, with continuous feedback and iteration.',
  icon: objectsIcon,
  alt: 'Interface Building Icon',
}

const UXCard3 = {
  title: 'Deliver & Optimize',
  parag: 'Interfaces are validated through usability testing and performance audits. SEO readiness and cross-device compatibility are ensured before deployment. Post-launch monitoring and documentation support ongoing improvement.',
  icon: threeDIcon,
  alt: 'Launch Optimization Icon',
}

         
// Folio Cards


const OdenloInfos = {
    title: 'Odenlo',
    role: 'Fullstack Developer',
    desc: 'Engineered a modern frontend architecture using React and Next.js, prioritizing modularity and reusability.',
    tag1: 'React',
    tag2: 'Next.js',
    tag3: 'Supabase',
    image: folioOdenlo,
    link: '/project-odenlo',
    side: 'left',
    color: '#ffffff'

    }


const DishopInfos = {
        title: 'Dishop App',
        role: 'UX Design / UI Design',
        desc: 'Designed and implemented the loyalty system for the mobile food ordering app ‘Dishop’.',
        tag1: 'Adobe XD',
        tag2: 'UX UI Design',
        tag3: 'Prototyping',
        image: folioDishop,
        link: '/project-dishop',
        side: 'right',
        color: '#ffffff'
        }

const FleetInfos = {
        title: 'Fleet Delivery',
        role: 'UX Design / UI Design',
        desc: 'Designed the User Experience of the app "Fleet" to optimize  delivery workflows and minimize friction.',
        tag1: 'Figma',
        tag2: 'UI Design',
        tag3: 'Design System',
        image: folioFleet,
        link: '/project-fleet',
        side: 'left',
        color: '#ffffff'

        }

const ProjectsInfos = {
        title: 'UI Projects',
        role: 'UI Design',   
        desc: 'A selection of UI Designs from past projects',
        tag1: 'Adobe XD',
        tag2: 'User Interface',
        tag3: 'Prototyping',
        image: folioProjectsUI,
        link: '/projects-multiple',
        side: 'right',
        color: '#ffffff'
        }

        
export default function Home (){

    const lenis = useLenis(({ scroll }) => {
        // called every scroll
      })
      
    const targetDiv = useRef(null);
    const targetDiv2 = useRef(null);

    const handleScrollToDiv = () => {
        if (targetDiv.current) {
        targetDiv.current.scrollIntoView({ behavior: 'smooth' });
        }
    };
    const handleScrollToDiv2 = () => {
        if (targetDiv2.current) {
        targetDiv2.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    document.addEventListener("DOMContentLoaded", (event) => {
        console.log("DOM fully loaded and parsed");
      });

    const [FolioTransition, setFolioTransition] = useState(2100+"px");
    const [OpacityB, setOpacityB] = useState('0.0');
    const [RidoBG, setRidoBG] = useState('#112233');
    const [RidoHeight, setRidoHeight] = useState('0px');
    const [LineRotate, setLineRotate] = useState('rotate(-447deg)');
    const [RotateValue, setRotateValue] = useState('1');

    const circleColor = "#525252";
    const myPurple="#ba75ec";

    
    const [LineColor, setLineColor] = useState('#565656');
    const [LineWidth, setLineWidth] = useState('391px;');
    const [DCircleSize, setDCircleSize] = useState('scale(1)');
  

    const [BgColor1, setBgColor1] = useState('');
    const [BgColor2, setBgColor2] = useState('');
    const [BgColor3, setBgColor3] = useState('');
    const [BgColor4, setBgColor4] = useState('');
    const [BgColor5, setBgColor5] = useState('');
    const [BgColor6, setBgColor6] = useState('');
    const [BgColor7, setBgColor7] = useState(myPurple);
    const [Circle1Size, setCircle1Size] = useState('1');
    const [Circle2Size, setCircle2Size] = useState('1');
    const [Circle3Size, setCircle3Size] = useState('1');
    const [Circle4Size, setCircle4Size] = useState('1');
    const [Circle5Size, setCircle5Size] = useState('1');
    const [Circle6Size, setCircle6Size] = useState('1');
    const [Circle7Size, setCircle7Size] = useState('1.4');
    const [Border5, setBorder5] = useState('0');
    const [Border7, setBorder7] = useState('0');
    const [SkillName, setSkillName] = useState('FE Developer');
    const [MouseY, setMouseY] = useState('');

    const [insideCircle, setInsideCircle] =useState(false)

    
    const handleCirlceHover = () => {

        setInsideCircle(true)
        setLineColor('#e0dc69');
        setLineWidth('211px');
        setDCircleSize('scale(1.01)')
    }


    const handleCirlceLeave = () => {
        setInsideCircle(false)
        setLineColor('#565656');
        setLineWidth('391px');
        setDCircleSize('scale(1)')

    }


    function timeout(delay: number) {
        return new Promise( res => setTimeout(res, delay) );
    }    
    
    
      // Function to extract the numerical value from the rotate string
    const extractRotateValue = (rotateString) => {
            const match = rotateString.match(/rotate\((\d+(\.\d+)?)deg\)/);
            console.log('Regex Match:', match);
            return match ? parseFloat(match[1]) : 0;
        };

    const handleMove = (e) => {

       
       
       if(!insideCircle) { setMouseY(e.clientY)

        if (RotateValue == -1514 ) {
                    
            setLineRotate('rotate(-'+e.clientY  + 'deg)');
        }
        

        if (MouseY  < 447 && MouseY  > 140) {
                    
            setLineRotate('rotate(-'+e.clientY  + 'deg)');
        }
        
        setRotateValue('-'+LineRotate.replace(/\D/g,''));



        {/* small Dot 1*/}
        if (RotateValue < -388 && RotateValue > -408) {
            
                setBgColor1(myPurple);
                setCircle1Size("1.4");
                setSkillName("Interaction Design")
            }else{

                setBgColor1(circleColor);
                setCircle1Size("1");
                setSkillName("[skill]")

            }


        {/* small Dot 2*/}
        if (RotateValue < -337 && RotateValue > -353) {
        
        setBgColor2(myPurple);
        setCircle2Size("1.4");
        setSkillName("Frontend Dev")

        }else{

            setBgColor2(circleColor);
            setCircle2Size("1");


        }

        {/* small Dot 3*/}
        if (RotateValue < -287 && RotateValue > -302) {
        
        setBgColor3(myPurple);
        setCircle3Size("1.4");
        setSkillName("Version control")

        }else{

            setBgColor3(circleColor);
            setCircle3Size("1");
        }


          {/* small Dot 4*/}
          if (RotateValue < -235 && RotateValue > -251) {
        
            setBgColor4(myPurple);
            setCircle4Size("1.4");
            setSkillName("SEO Optimisation")
    

            }else{

                setBgColor4(circleColor);
                setCircle4Size("1");


            }

          {/* small Dot 5*/}
          if (RotateValue < -181 && RotateValue > -198) {
        
            setBgColor5(myPurple);
            setCircle5Size("1.4");
            setSkillName("User testing");
            setBorder5('1');
    

            }else{

                setBgColor5(circleColor);
                setCircle5Size("1");
                setBorder5('0');



            }

          {/* small Dot 6*/}
          if (RotateValue < -128 && RotateValue > -151 ) {
        
            setBgColor6(myPurple);
            setCircle6Size("1.4");
            setSkillName("CI/ CD ")
    

            }else{

                setBgColor6(circleColor);
                setCircle6Size("1");


            }

          {/* small Dot 7*/}
          if (RotateValue < -437 && RotateValue > -455 ) {
        
            setBgColor7(myPurple);
            setCircle7Size("1.4");
            setSkillName("UX UI Design")
            setBorder7('1');

    

            }else{

                setBgColor7(circleColor);
                setCircle7Size("1");
                setBorder7('0');
            }

          {/* Rewind*/}
          if (RotateValue < -92 && RotateValue > -115 ) {
        
            setLineRotate('-469deg')
    

            }
        }else{


            }
        }


        function handleDotHover(circleNum){



          {/* small Dot 7*/}
        if (circleNum === 2) {

            setLineRotate('rotate(-448deg)')
                setBgColor7(myPurple);
                setCircle7Size("1.4");
            setSkillName("UX UI Design")
        }
         

        {/* small Dot 1*/}
        if (circleNum === 3) {

            setLineRotate('rotate(-397deg)')
                setBgColor1(myPurple);
                setCircle1Size("1.4");
                setSkillName("Interaction Design")
        }
         
        {/* small Dot 2*/}
        if (circleNum === 4) {

            setLineRotate('rotate(-345deg)')
       setBgColor2(myPurple);
        setCircle2Size("1.4");
        setSkillName("Frontend Dev")
        }
         
        {/* small Dot 3*/}
        if (circleNum === 5) {

            setLineRotate('rotate(-295deg)')

    setBgColor3(myPurple);
        setCircle3Size("1.4");
        setSkillName("Version control")
        }
         
          {/* small Dot 4*/}
        if (circleNum === 6) {

            setLineRotate('rotate(-242deg)')
  
            setBgColor4(myPurple);
            setCircle4Size("1.4");
            setSkillName("SEO Optimisation")
        }
         
         
          {/* small Dot 5*/}
        if (circleNum === 7) {

            setLineRotate('rotate(-190deg)')
  
          setBgColor5(myPurple);
            setCircle5Size("1.4");
            setSkillName("User testing");
        }
         

          {/* small Dot 6*/}
        if (circleNum === 1) {

            setLineRotate('rotate(-142deg)')
                setBgColor6(myPurple);
                setCircle6Size("1.4");
            setSkillName("CI/ CD ")
        }
    }

    function onDotLeave(){


            setBgColor6(circleColor);
                setCircle6Size("1");
            setSkillName("[skill]")

            setBgColor1(circleColor);
setCircle1Size("1");
setSkillName("[skill]");

setBgColor2(circleColor);
setCircle2Size("1");
setSkillName("[skill]");

setBgColor3(circleColor);
setCircle3Size("1");
setSkillName("[skill]");

setBgColor4(circleColor);
setCircle4Size("1");
setSkillName("[skill]");

setBgColor5(circleColor);
setCircle5Size("1");
setSkillName("[skill]");

setBgColor7(circleColor);
setCircle7Size("1");
setSkillName("[skill]");

    }

    const animateRido = async () =>{
        setFolioTransition(window.scrollY + window.innerHeight);

        await timeout(40);
        setRidoHeight("1555px");


        setFolioTransition("0px");
        setOpacityB("1");
    }


    
    const { scrollYProgress } = useScroll();



    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    
    const arrowVH = window.innerHeight -161+"px";

    document.addEventListener("scroll", (event) => {


      });


    return (

        <ScrollToTop>


        {/*<motion.div initial= {{opacity:0}} animate= {{opacity:1}} exit= {{opacity: 0}} transition = {{ duration: 1, ease: [0.22, 1, 0.36, 1]}}>*/}
        <motion.div initial= {{opacity:0}} animate= {{opacity:1}} exit={{opacity: 1}} transition = {{ duration: 1, ease: [0.22, 1, 0.36, 1]}}  style={{ top: {FolioTransition}}} >

        <div class='rootBody' onMouseMove={handleMove}  style={{'scroll-behavior': 'smooth'}} >


            <div class="Rido" style={{top: FolioTransition, height: RidoHeight, 'background-color': '#ffffff', opacity: OpacityB}}></div>
            {/* Rest of the code */}

            <div class="homePage" id="home"  >
                <div class="menu"  style={{ position: 'sticky', top: 0, 'z-index': '0'}}>
                    <div class="siteName"><Link to="/" style={{ 'text-decoration': 'none'}}><img src={YBlogo}/></Link></div>
                    <div class="menuLinks">

                    <div onClick={handleScrollToDiv2}  class="link">Work</div>
                    <Link to="/about" style={{  'text-decoration': 'none'}}><div class="link">About</div></Link>
                    <Link to="/contact" style={{  'text-decoration': 'none'}}><div class="link">Contact</div></Link>

                        {/* EN | FR */}

                    </div>

                    
                </div>

                        {/* <div className="animated-paragraph">
                            <p className="pargLine" style={{ animationDelay: '0.03s' }}>This is the first line.</p>
                            <p className="line" style={{ animationDelay: '0.1s' }}>Here comes the second line.</p>
                            <p className="line" style={{ animationDelay: '0.12s' }}>This is the third line!</p>
                        </div> */}

                    <div class="heroSection" style={{ position: 'sticky', top: 75}}>


                        {/*ARROW SCROLL*/}

                        <motion.div initial={{opacity: 0}} animate={{ translateY: 13, opacity: .6}} transition={{ repeat: Infinity, duration: 1, repeatDelay: 2 }}  style={{ position: 'absolute', top: arrowVH, opacity: '0.7'}}>
                         <div onClick={handleScrollToDiv} style={{cursor: 'pointer'}}><img src={arrowDown} /></div>
                        </motion.div>

                            <div class="heroLeft" style={{ 'margin-top': '-112px' }}>
                                <div class="heroText" id="introText">
                                 
                                <div class="heroSMText" style={{'z-index': '1'}}>
                                    
                                    <div className= 'paragLine' style={{ animationDelay: '0.2s'}}>  Hello, my name is&nbsp;</div>
                                    <div className= 'paragLine' style={{ animationDelay: '0.1s'}}><span style={{ 'background-color': '#ffffff', padding: '0 11px 0 11px', 'margin-left': '', height: '33px', 'z-index': '-99'}}>Yacine Benziane</span></div></div>

                                    <div className= 'paragLine' style={{ animationDelay: '0.2s'}}>I'm a Frontend&nbsp;</div>
                                    <div className= 'paragLine' style={{ animationDelay: '0.3s' }}> Developer&nbsp;</div>

                                <div className= 'paragLine' style={{ animationDelay: '0.4s' }}>with a&nbsp;</div>
                                <div className= 'paragLine' style={{ animationDelay: '0.5s' }}> background in&nbsp;</div>
                                <div className= 'paragLine' style={{ animationDelay: '0.6s' }}>UX/UI&nbsp;</div>
                                <div className= 'paragLine' style={{ animationDelay: '0.7s' }}>Design.</div>
                            </div>
                        </div>
                        
                        <div class="heroRight" style={{'margin-top': '-112px'}}>

                            <div class="darkCircle" onMouseEnter={handleCirlceHover} onMouseLeave={handleCirlceLeave} style={{transform: DCircleSize}}>
                                <div class="darkCircleOutline"/>
                                <div style={{color: myPurple, 'z-index': '1'}}>{SkillName}</div>
                                <div class="line" style={{transform: LineRotate, 'border-bottom': 'solid 1px '+ LineColor, width: LineWidth}}/>
                                <div class="smallDotHolder"  style={{transform: 'rotate(0deg)'}}> <div onMouseEnter={()=> handleDotHover(2)} onMouseLeave={()=>onDotLeave()}  class="smallDot" style = {{transform: 'scale('+Circle7Size+')', backgroundColor: BgColor7, 'box-shadow': '0px 0px  1px '+Border7+'px#5c5c5c'}}/> </div>
                                <div class="smallDotHolder"  style={{transform: 'rotate(51.4deg)'}}> <div onMouseEnter={()=> handleDotHover(3)} onMouseLeave={()=>onDotLeave()}  class="smallDot" style = {{transform: 'scale('+Circle1Size+')', backgroundColor: BgColor1}}/> </div>
                                <div class="smallDotHolder"  style={{transform: 'rotate(102.8deg)'}}> <div onMouseEnter={()=> handleDotHover(4)} onMouseLeave={()=>onDotLeave()}  class="smallDot" style = {{transform: 'scale('+Circle2Size+')', backgroundColor: BgColor2}}/> </div>
                                <div  class="smallDotHolder"  style={{transform: 'rotate(154deg)'}}> <div onMouseEnter={()=> handleDotHover(5)} onMouseLeave={()=>onDotLeave()} class="smallDot" style = {{transform: 'scale('+Circle3Size+')', backgroundColor: BgColor3}}/> </div>
                                <div class="smallDotHolder"  style={{transform: 'rotate(205deg)'}}> <div onMouseEnter={()=> handleDotHover(6)} onMouseLeave={()=>onDotLeave()}  class="smallDot" style = {{transform: 'scale('+Circle4Size+')', backgroundColor: BgColor4}}/> </div>
                                <div  class="smallDotHolder"  style={{transform: 'rotate(257deg)'}}> <div onMouseEnter={()=> handleDotHover(7)} onMouseLeave={()=>onDotLeave()} class="smallDot" style = {{transform: 'scale('+Circle5Size+')', backgroundColor: BgColor5, 'box-shadow': '0px 0px  1px '+Border5+'px #5c5c5c'}}/> </div>
                                <div class="smallDotHolder"  style={{transform: 'rotate(308deg)'}}> <div onMouseEnter={()=> handleDotHover(1)} onMouseLeave={()=>onDotLeave()}  class="smallDot" style = {{transform: 'scale('+Circle6Size+')', backgroundColor: BgColor6}}/> </div>
                            </div>
                        </div>
                    </div>
                    <p class="degNum" style={{fontSize: '15px', fontWeight: 800, position: 'absolute', top: '45%', right: '-21px', transform: 'rotate(90deg)'}}>{RotateValue}  deg</p>
               
               
               
               {/* PROCESS CARDS */}
               
                <div class='darkBG' id="process" ref={targetDiv}>

                    <motion.div id="arrow2" initial={{opacity: 0}} animate={{ translateY: 13, opacity: .6}} transition={{ repeat: Infinity, duration: 1, repeatDelay: 2 }}  style={{ position: 'absolute', top: '88vh', opacity: '0.7'}}>
                        <div onClick={handleScrollToDiv2} style={{cursor: 'pointer'}}><img src={arrowDown} style={{filter: 'invert(.7)'}} /></div>
                    </motion.div>

                    <div class="homeTitle" style={{'color': '#cdcdcd', 'margin-bottom': '10%'}}>
                        Process  
                        <div class="shortLine2" style= {{'border-bottom': 'solid 1px #5f5f5f'}}/>

                        </div>
                    <div id="boxes">
                        <Card UXCard={UXCard1}/>
                        <Card UXCard={UXCard2} />
                        <Card UXCard={UXCard3} />
                    </div>
                </div>
        

                <div class='folioMenuContainer' id="projects" ref={targetDiv2} style={{position: 'sticky', top: 0,'z-index': '2'}}>
                    
                    <div class="homeTitle" style={{'color': '#343434', 'margin-bottom': '3%'}}>
                        Projects 
                        <div class="shortLine2" style= {{'border-bottom': 'solid 1px #343434', }}/>
                    </div>
                        <div class="cardsContainer">
                            <FolioCard FolioInfos={OdenloInfos} animateRido={animateRido} setRidoBG={setRidoBG} setFolioTransition={setFolioTransition}/>
                            
                            <FolioCard FolioInfos={DishopInfos} animateRido={animateRido} setRidoBG={setRidoBG} setFolioTransition={setFolioTransition}/>

                            <FolioCard FolioInfos={FleetInfos} animateRido={animateRido} setRidoBG={setRidoBG} setFolioTransition={setFolioTransition}/>

                            <FolioCard FolioInfos={ProjectsInfos} animateRido={animateRido} setRidoBG={setRidoBG} setFolioTransition={setFolioTransition}/>
                        </div>

                    <FooterHome/>

                </div>

         
            </div>
        </div>
        
        </motion.div>


        </ScrollToTop>
        )

    }
